import api from '@/factories/api';

export default {
  async performPortalSearch({ commit }, search) {
    commit('setCurrentSearch', search);

    const results = await api().get(
      `cg/search?query=${search}&search_lessons=true`
    );
    const convertedResults = filterSearchResults(results, search);
    commit('setSearchResults', convertedResults);

    return results;
  },
};

const filterSearchResults = (results, search) => {
  if (Array.isArray(results) && !results.length) {
    return null;
  }

  const filteredResults = {
    joinedCourses: [],
    availableCourses: [],
    folders: [],
  };

  return results.reduce((acc, course) => {
    let type = !course.status
      ? 'folders'
      : (course.status === 'playing' ? 'joined' : 'available') + 'Courses';

    if (!course.triggers) {
      course.triggers = [];
      acc[type].push(course);
    } else {
      if (
        course.triggers.length ||
        (!course.triggers.length && compareStrings(course.name, search))
      ) {
        acc[type].push(course);
      }
    }

    return acc;
  }, filteredResults);
};

const compareStrings = (fullString, search) => {
  return fullString.toLowerCase().includes(search.toLowerCase());
};
